import { render, staticRenderFns } from "./ReservePatientSearch.vue?vue&type=template&id=631f1adc&scoped=true"
import script from "./ReservePatientSearch.vue?vue&type=script&lang=js"
export * from "./ReservePatientSearch.vue?vue&type=script&lang=js"
import style0 from "./ReservePatientSearch.vue?vue&type=style&index=0&id=631f1adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f1adc",
  null
  
)

export default component.exports